<template>
    <MainContentSearchable title="Listado de comunicados" id="comunicados" v-model="filters" :meta="loading ? {} : comunicados.meta" @updated="debouncedGetComunicados">
        <template v-slot:header>
            <h3 class="card-title" my-3></h3>
            <div class="card-tools">
                <router-link :to="{ name: 'back.comunicados.recordatorios.index' }" class="btn btn-primary m-3">
                    EMAILS RECORDATORIOS
                </router-link>
                <router-link :to="{ name: 'back.comunicados.emails.index' }" class="btn btn-primary m-3">
                    EMAILS ALTERNATIVOS
                </router-link>
                <router-link :to="{ name: 'back.comunicados.bases.index' }" class="btn btn-primary m-3">
                    BASES DE EMAILS
                </router-link>
                <router-link :to="{ name: 'back.comunicados.crear' }" class="btn btn-primary m-3">
                    CREAR COMUNICADO
                </router-link>
            </div>
        </template>

        <template v-slot:content v-if="!loading && comunicados">
            <div class="table-responsive has-options">
                <b-table hover :items="comunicados.data" :fields="fields">
                    <template #cell(listo_para_enviar)="data">
                        {{ data.value ? 'Si' : 'No' }}
                    </template>

                    <template #cell(enviado)="data">
                        <CheckOrCross :condition="data.value"/>
                    </template>

                    <template #cell(id)="data">
                        <OpcionesDropdownComponent v-bind:options="[
                                            { to: { name: 'back.comunicados.editar', params: { comunicado_id: data.value}}, label: 'Editar'},
                                            { type: 'action', action:() => showModal('borrar-' + data.value), label: 'Borrar'},
                                            { to: { name: 'back.comunicados.estadisticas', params: { comunicado_id: data.value}}, label: 'Estadísticas emails'},
                                            { type: 'action', action:() => showModal('comunicado-' + data.value), label: 'Enviar'},
                                            { type: 'action', action:() => showModal('prueba-' + data.value), label: 'Enviar prueba'},
                                        ]"/>
                        <BorrarModal :comunicado="data.item" v-on:close="closeModal"></BorrarModal>
                        <EnviarPrueba :comunicado="data.item" v-on:close="closeModal"></EnviarPrueba>
                        <EnviarComunicado :comunicado="data.item" :events="events" :bases="bases" :recordatorios="recordatorios.data" v-on:close="closeModal"></EnviarComunicado>
                    </template>
                </b-table>
            </div> 
        </template>
    </MainContentSearchable>
</template>

<script>
import BorrarModal from './modals/Delete';
import EnviarPrueba from './modals/EnviarPrueba';
import EnviarComunicado from './modals/EnviarComunicado';
import CheckOrCross from "@/components/backend/components/CheckOrCross";
import MainContentSearchable from "@/components/backend/components/MainContentSearchable";
import OpcionesDropdownComponent from "@/components/backend/components/OpcionesDropdownComponent";

export default {
    data() {
        return {
            comunicados: { meta: { current_page: 1 } },
            loading: true,
            filters: {
                per_page: 10,
                page: 1,
                search: '',
                search_for: 'n_abonado',
                tipo: null
            },
            fields: [
                { key: 'titulo', label: 'título'},
                'asunto',
                { key: 'listo_para_enviar', label: 'Listo para enviar' },
                { key: 'fecha_envio', label: 'Fecha de envio' },
                { key: 'enviado', class: 'text-center' },
                { key: 'id', label: 'opciones', class: 'text-center' }
            ],
            events: [],
            bases: [],
            recordatorios: []
        }
    },
    created() {
        this.getComunicados();
        this.getEvents();
        this.getBases();
        this.debouncedGetComunicados = _.debounce(this.getComunicados, 500)
    },
    methods: {
        borrar(id) {
            this.loading = true;

            const params = {
                filters : {},
                comunicado_id: id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.borrar'), params).then(res => {
                this.$toast.success(res.data.message);
                this.getComunicados();
            }).finally(() => this.loading = false);
        },
        getComunicados : function() {
            this.loading = true;

            const params = {
                filters : this.filters
            };

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.index'), params).then(res => {
                this.comunicados = res.data;
            }).finally(() => this.loading = false);
        },
        setPage(page) {
            this.filters.page = page;
            this.getComunicados();
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal, borrado) {
            this.$modal.hide(modal);
            if(borrado) {
                this.getComunicados();
            }
        },
        getEvents : function() {
            this.loading = true;
            const data = {
                filters: {
                    to_select: true,
                }
            };
            this.$store.dispatch(this.config.getVuexAlias('back.events.index'), data).then(res => {
                this.events = res.data;
            }).finally(() => this.loading = false);
        },
        getBases : function() {
            this.loading = true;

            const params = {
                filters: {
                    per_page: 100,
                    page: 1,
                    search: ''
                }
            }

            this.$store.dispatch(this.config.getVuexAlias('back.comunicados.bases.index'), params).then(res => {
                this.bases = res.data.data;
            }).finally(() => this.loading = false);
        }
    },
    components: {
        OpcionesDropdownComponent,
        MainContentSearchable, CheckOrCross, BorrarModal, EnviarPrueba, EnviarComunicado
    }
}
</script>
